// import { I } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QualService } from 'src/app/qual/service/qual.service';
import { InsightsService } from 'src/app/shared/insights/service/insights.service';
import { SharedataService } from 'src/app/shared/share/service/sharedata.service';
import { HomeService } from 'src/app/shared/services/home.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';
import { ReportService, ReportDetails } from '../service/report.service';
import loader from "../../../assets/json/Loader_1_lf30_editor_qscoqhrb.json"
import { DialogContainerComponent } from "../dialog-container/dialog-container.component";
import { MatDialog } from '@angular/material/dialog';
import { TrackerService } from '../service/tracker.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../service/repo-api.service';
// import { downloadZip } from 'client-zip';
import * as streamSaver from 'streamsaver';
import { AdvancedSearchService } from 'src/app/shared/advanced-search/advanced-search.service';
// import jszip from 'jszip';
// import { InputWithMeta, InputWithSizeMeta, InputWithoutMeta, InputFolder } from 'client-zip'; // Import necessary types




@Component({
  selector: 'report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit, OnDestroy {

  public status = '';
  public uuid: string = '';
  public isKPIExpanded: boolean = false;
  public shouldKPIExpandedVisible: boolean = false;
  public isCoverageTableExpanded: boolean = false;
  public isMethodology: boolean = false;
  public isUploadFile: boolean = false;
  public isRequestFile: boolean = false;
  public downloadArrowIconForFile:boolean = true;
  public studyHasDownloadAllFilleAcces:string[] = [
    "9bd32e47-2e29-4fc6-8747-0a760f6d96ed",
    "d994111d-f9e8-443f-a7b8-ad48ff90d4c1",
    "22f42155-3559-4007-8260-3191b48802cb"
  ];
  public isSearchText:boolean = false;
  public searchText:string = "";
  public scrollDistance = 1;
  public throttle = 10;
  public page = 1;
  public page_size = 20;
  public totalFilePage = 2;
  @ViewChild('defaultScrollTarget') defaultScrollTarget:ElementRef;
  private routeParamsSub: Subscription;
  public isSwitchingStudyInProject = false;
  public accessRoles:any;

  // public isQual: boolean = false;
  // public isReport : boolean = false;
  constructor(
    public reportService: ReportService,
    public repoService: RepoApiService,
    public sidePanelService: SidePanelService,
    public homeService: HomeService,
    private activaterRoute: ActivatedRoute,
    public iService: InsightsService,
    public sService: SharedataService,
    public dialog: MatDialog,
    private router: Router,
    public QService: QualService,
    public notifier: NotifierService,
    public trackerService: TrackerService,
    public aSearchservice:AdvancedSearchService
    ) {
    this.reportService.isQual = false;
    this.reportService.isReport = false;
    this.reportService.repoDetailsSearchEventEmit.subscribe((str)=>{
      this.onSearchChange(str);
    })

    // Subscribe to route params to handle navigation between different UUIDs
    // Only handle SUBSEQUENT param changes here - initial load is handled by ngOnInit
    this.routeParamsSub = this.activaterRoute.params.subscribe(params => {
      const newUuid = params['uuid'];
      // Only reinitialize if UUID actually changes AFTER initial load
      if (this.uuid && newUuid && this.uuid !== newUuid) {
        this.uuid = newUuid;
        this.isSwitchingStudyInProject = true;
        this.reportService.closeGroupSummary();
        this.initializeComponent();
        this.aSearchservice.resetSearch(true);

      }
    });
  }

  ngOnInit() {
    // Get initial UUID from route params
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.isSwitchingStudyInProject = false;
    this.initializeComponent();
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  initializeComponent() {
    // Reset the side panel initialization flag when loading a new study
    if(!this.isSwitchingStudyInProject){
      this.sidePanelService.resetSideDrawer();
    }
    this.reportService.resetSidePanelInitFlag();
    
    this.iService.close();
    this.QService.getStudyId();
    this.reportService.studyId = this.QService.studyId;
    this.iService.VOCList = null;
    this.reportService.reportDetails = new ReportDetails()
    if (this.router.url.includes('qual')) {
      // this.QService.isOpen = true;
      // this.isQual = true;
      this.homeService.isOpen = true;
      this.reportService.isQual = true;
      this.sidePanelService.initSideDrawer('qual');
      this.homeService.checkRepoDetailsEvent.emit(this.QService.studyId);
      // this.sidePanelService.getVisibility(this.reportService.studyId);
      // this.reportService.reportDetails = new ReportDetails();
      this.QService.getInterviewDetails();

    } else {
      // this.isReport = true;

      this.reportService.isReport = true;
      this.getRepositoryDetails();
    }
    if (this.isDownloadAll()) {
      this.reportService.getAllDownloadableZipFiles(this.uuid);
    }else{
      this.reportService.getAllDownloadableFiles(this.uuid);
    }
    this.reportService.isHideFileListForSpecificStudies = this.isDownloadAll();
    // this.iService.getInsightList({"uuid":this.uuid,"type":"study"})
    this.reportService.detailsUUID = this.uuid;
    this.reportService.getComments(this.uuid, 'study');
    this.reportService.checkVocAccess();
    this.reportService.checkSignTestUserLevelAccess();
    this.reportService.isRepoDetailsSearch = true;
    this.reportService.isRepoSearch = false;
    this.reportService.searchText = '';
  }

  ngOnDestroy() {
    if (this.routeParamsSub) {
      this.routeParamsSub.unsubscribe();
    }
    this.reportService.closeFile();
    this.reportService.closeGroupSummary();
    this.reportService.destroyDownloadAllFiles();
    this.iService.close();
    this.sService.close();
    this.reportService.isUpload = false;
    this.reportService.researchDetails = {};
    this.reportService.reportDetailFiles = []
    // this.reportService.reportDetails = new ReportDetails()
    this.iService.VOCList = null;
    // this.reportService.projectDetails = {};
    this.iService.vocStudyLevelArray = null;
    this.iService.VOCClubList = null;
    this.iService.VOCsToBeClub = null;
    this.reportService.isUploadFile = false;
    this.reportService.isRequestFile = false;
    this.reportService.isCallRecording = false;
    this.reportService.studySummaryInnerHtml = "";
    this.reportService.studySummarySafeInnerHtml = "";
    this.reportService.isShowStudySummary = false;
    this.aSearchservice.closeSearch();
    this.aSearchservice.resetSearch(true);
    // this.reportService.hasSigTestAccess = false;
  }

  resetPasinationQuery(){
    this.page = 1;
    let query = {
      "page":this.page,
      "page_size":this.page_size
    };
    if (this.searchText.length > 2 ) {
      query['search'] = this.searchText
    }
    if (this.defaultScrollTarget && this.defaultScrollTarget.nativeElement) {
      this.defaultScrollTarget.nativeElement.scrollIntoView()
    }
    return query;
  }

  breadcrumbClick() {
    if (this.reportService.isQual) {
      this.router.navigate(['qual/interview/', this.QService.studyId]);
      // this.router.navigate(['home/qual/interview/', this.QService.studyId]);
    }
    else {
      this.router.navigate(['repo']);
      // this.router.navigate(['home/repository-report']);
    }
  }

  isDownloadAll(){
    return this.studyHasDownloadAllFilleAcces.includes(this.uuid)
  }
  getRepositoryDetails() {
    // this.page = 1;
    // let query = {
    //   "page":this.page,
    //   "page_size":this.page_size,
    //   "search":this.searchText
    // }
    let query = this.resetPasinationQuery()
    this.reportService.getRepositoryDetail(this.uuid,query);
    this.reportService.getRepositoryFilesPagination(this.uuid,query);
    // setTimeout(() => {
    //   this.sidePanelService.initSideDrawer('repo');
    // },500)
  }
  openUploadFilePanel = () => {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.reportService.isUploadFile = !this.reportService.isAudioFile;
    }
  }
  openRequestFilePanel = () => {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.reportService.isRequestFile = !this.reportService.isRequestFile;
    }
  }
  showCommentPanel() {
    this.iService.openInsight(this.uuid, 'study', "");
  }
  showSharePanel() {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.sService.openSharePanel(this.uuid, 'study');
    }
  }

  ChangeUploadState = () => {
    this.isUploadFile = !this.isUploadFile;
  }

  expandKPI() {
    this.isKPIExpanded = !this.isKPIExpanded;
    if (this.isKPIExpanded) {
      let data = {}
      data['uuid'] = this.uuid;
      data['file_type'] = 'dynaview';
      data['action'] = 'expand';
      // data['misc'] = {'action':'expand'};
      this.trackerService.submitTracker(data);
    }
    this.reportService.researchDetails.concepts_details.forEach((concept, index) => {
      if (this.reportService.researchDetails.concepts_details[index].kpiLength > 3) this.reportService.researchDetails.concepts_details[index].isKPIExpanded = this.isKPIExpanded;
    })
  }

  triggerCoverageTableView = (n) => this.isCoverageTableExpanded = n == 1 ? true : false;

  gridTemplateColumns = (length) => ({ 'grid-template-columns': `repeat(${length + 1}, 1fr)` });

  editDetails() {
    this.reportService.isUpload = true;
  }
  showVocPanel() {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.iService.openVOC(this.uuid, 'study');
    }
  }
  assignLength(file: any){
    if (file.length < 5) {
      return 43;
    }
    else if (file.length == 5) {
      return 40;
    }
    else if (file.length > 5 && file.length <= 10) {
      return 35;
    }
    return 30;
  }


  moreFileActions(index: number, e) {
    e.stopPropagation();
  }

  shareFile(file) {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.iService.close();
      this.reportService.close();
      this.sService.openSharePanel(file.file_uuid, 'file');
    }
  }

  replaceFile(file) {
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.reportService.replaceFileObj = {"file_uuid": file.file_uuid};
      this.reportService.isUploadFile = true;
    }
  }

  deleteFile(file) {
    this.openFileDeleteConfirmationPopup(file,this.uuid);
  }

  openFileDeleteConfirmationPopup(file,uuid) {
    this.dialog.open(DialogContainerComponent, {
      width: '344px',
      height: "175px",
      disableClose: true,
      data: { file: file, method: 'fileDelete' ,studyUUID:uuid}
    });
  }


  openDialog(index, concept) {
    this.dialog.open(DialogContainerComponent, {
      width: '770px',
      height: "430px",
      disableClose: true,
      data: { index: index, method: 'concept' }
    });

    let data = {}
    data['uuid'] = this.uuid;
    data['file_type'] = 'dynaview';
    data['action'] = 'view';
    data['misc'] = { 'concept': concept };
    this.trackerService.submitTracker(data);
  }
  HambergerDropdown()
  {
    this.downloadArrowIconForFile != this.downloadArrowIconForFile;
    
  }
  DownloadFileFromStudyPage(file,type?:string)
  {
    let Ahref: HTMLElement = document.getElementById("downloadFIleURLStudy");
    if (file.processing) {
      this.notifier.notify('warning', 'File is currently processing and cannot be downloaded.');
      return;
    }
    this.reportService.ahref = Ahref;
    this.reportService.detailsUUID = file['file_uuid'];
    this.reportService.fileName = file['name'];
    this.reportService.fileType = file['type'];
    this.reportService.isAudioFile = false;
    this.reportService.isVideoFile = false;
    // this.reportService.downloadRequestFromService(type);
    if (type === 'pdf' || type === 'word') {
      this.reportService.downloadICVTranscript(type);
    }else{
      this.reportService.downloadRequestFromService(type);
    }
  }

  
  CheckDisability(file:any,str:any){
    if(file['dataTableStatus'] === 'complete')
    {
      return false;
    }
    else
    {
      if(file['file_type'].includes('ABS') && str === 'abs')
      {
        return false;
      }
      if(file['file_type'].includes('PCT') && str === 'pct')
      {
        return false;
      }
      return true;
    }

  }


  moveFileComponent(file:any){
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.reportService.movingToplineFileDetails = file;
      this.reportService.isMovingFileComponent = true;
    }
  }
  editFile(file:any){
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      this.reportService.file_repo_id = file.id;
      this.reportService.isFileUpdatePanelOpen = true;
      this.reportService.MatSelectFileArray = [];
      let obj = {
        file_type: file.file_type,
        value: file.name,
        vi_index: false,
        language:''
      }
      this.reportService.MatSelectFileArray.push(obj);
    }
  }

  

  editFileName(file:any){
    if(file && file.edit){
      file['editFileName'] = true;
    }
  }


  editNameCompleted(file:any,event:any,type:any){
    let name = event.currentTarget.value;
    if(type=='desc'){
      if(!name && name=='' || name == 'NA'){
        this.notifier.notify('error','Details cannot be blank');
      }else{
        file.editDescName = false;
        // let type = file.name.split('.')[1];
        // if(!name.includes(type)){
        //   name += '.'+type;
        // }
        let body = {file_id:file.file_uuid,name:name,type:'details'};
        this.repoService.renameFileName(body).subscribe(result =>{
          if(result['status'] == 1){
            this.notifier.notify('success','Details Data update');
            let query = this.resetPasinationQuery()
            this.reportService.getRepositoryDetail(this.reportService.studyId,query);
            this.reportService.getRepositoryFilesPagination(this.uuid,query);

          }else{
            this.notifier.notify("error","Something went wrong!")
          }
        })
      }
    }else{
      if(!name && name==''){
        this.notifier.notify('error','File name cannot be blank');
      }else{
        file.editFileName = false;
        let type = file.name.split('.')[1];
        if(file && file.download_resource && file.download_resource.length){
          type = file.download_resource[0].split('.')[file.download_resource[0].split('.').length-1];
        }
        if(!name.includes(type)){
          name += '.'+type;
        }
        let body = {file_id:file.file_uuid,name:name,type:'name'};
        this.repoService.renameFileName(body).subscribe(result =>{
          if(result['status'] == 1){
            this.notifier.notify('success','File name update');
            let query = this.resetPasinationQuery()
            this.reportService.getRepositoryDetail(this.reportService.studyId,query);
            this.reportService.getRepositoryFilesPagination(this.uuid,query);
          }else{
            this.notifier.notify("error","Something went wrong!")
          }
        })
      }
    }

  }


  editDescripationName(file:any){
    if(file && file.edit){
      file['editDescName'] = true;
    }
  }


  copyApiCallFunction(file:any){
    if(this.sidePanelService.isGuestAccount){
      this.notifier.notify('warning', this.sidePanelService.genericAccountNotification);
    }else{
      if(file.dataTable && file.dataTableStatus == 'pending' || file.kpiViewerStatus== 'pending' || file.translation_processing){
        this.notifier.notify('error','File in Processing... Please wait');
  
      }else{
        let study_id = this.reportService.studyId;
        let body = {file_id:file.file_uuid,study_id:study_id};
        this.repoService.copyFile(body).subscribe(result =>{
          if(result['status'] == 1){
            this.notifier.notify('success','File copy successfully');
            let query = this.resetPasinationQuery()
            this.reportService.getRepositoryDetail(study_id,query);
            this.reportService.getRepositoryFilesPagination(this.uuid,query);
          }else{
            this.notifier.notify("error","Something went wrong!")
          }
        })
      }
    }
  }

  // getdownloadAll(){
  //   this.notifier.notify('success','Download in progress. All files will be downloaded shortly.!');
  //   this.repoService.getdownloadAll(this.reportService.studyId).subscribe(result =>{
  //     if(result[0]['status'] == 1){
  //       const link = document.createElement('a');
  //       link.href = result[0]['url'];
  //       link.setAttribute('download', `${this.reportService.studyId}-files.zip`);
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     }else{
  //       this.notifier.notify("error",result['message']);
  //     }
  //   })
  // }

  getdownloadAll(){
    this.repoService.getdownloadAll(this.reportService.studyId).subscribe(result =>{
      if(result['status'] == 1){
        this.notifier.notify('success',result['message']);
        // this.downloadAndZipFiles(result['data']);
      }else{
        this.notifier.notify("error",result['message']);
      }
    })
  }

  // async downloadAndZipFiles(files) {
  //   const _file: (InputWithMeta | InputWithSizeMeta | InputWithoutMeta | InputFolder)[] = await Promise.all(files.map(async (va) => {
  //     const response = await fetch(va['url']);
  //     const blob = await response.blob();
      
  //     return {'name': va['filename'], 'input': blob};
  //   }));
 

  //   // downloadZip(_file).body.pipeTo(streamSaver.createWriteStream('allFiles.zip'));
  // }


  
  // async downloadAndZipFiles(files) {

  //   let _file = files.map(async function(va){
  //     return {'name':va['filename'],'input':await fetch(va['url'])}
  //   })
  //   const zipStream = downloadZip(_file).body;
  //   const fileStream = streamSaver.createWriteStream('final_name.zip');
  //   if (window.WritableStream && zipStream.pipeTo) {
  //     zipStream.pipeTo(fileStream);
  //   } else {
  //     const writer = fileStream.getWriter();
  //     const reader = zipStream.getReader();
  //     const pump = () => reader.read().then(({ done, value }) => done ? writer.close() : writer.write(value).then(pump));
  //     pump();
  //   }
  // }




  // async downloadAndZipFiles(files) {
  //   const zip = new jszip();

  //   const promises = files.map(async (va, index) => {
  //     const response = await fetch(va['url']);
  //     const blob = await response.blob();
  //     zip.file(va['filename'], blob);
  //   });

  //   await Promise.all(promises);

  //   zip.generateAsync({ type: 'blob' }).then(function(content) {
  //     const link = document.createElement('a');
  //     link.download = 'downloadAll.zip';
  //     link.href = window.URL.createObjectURL(content);
  //     link.click();
  //   });
  // }

  onSearchChange(value:string){
    this.searchText = value;
    if (this.reportService.isQual) {
      this.QService.onSearchChange(this.searchText)
    }else{

      if (this.searchText.length > 2 ) {
        let query = this.resetPasinationQuery();
        this.isSearchText = true
        // query['search'] = this.searchText
        // this.reportService.getRepositoryDetailPagination(this.uuid,query);
        this.reportService.getRepositoryFilesPagination(this.uuid,query);
        
      }
      if (this.isSearchText && this.searchText == '') {
        this.isSearchText = false;
        let query = this.resetPasinationQuery();
        // this.reportService.getRepositoryDetailPagination(this.uuid,query);
        this.reportService.getRepositoryFilesPagination(this.uuid,query);
      }
    }
  }

  onScroll(){
    if (!this.reportService.isScroleComleted && !this.router.url.includes('qual')) {
      this.page++;
      let query = {"page":this.page,"page_size":this.page_size};
      if (this.searchText && this.searchText != "" && this.searchText.length > 2) {
        query['search'] = this.searchText
      }
      // this.reportService.getRepositoryDetailPagination(this.uuid,query);
      this.reportService.getRepositoryFilesPagination(this.uuid,query);
    }
  }
  
  generateStudyAISummary(){
  // this.reportService.reportDetails.study_summary.status = 3;
    if(!this.reportService.reportDetails.objective){
      this.notifier.notify('error','Please add objective to generate summary');
      return;
    }
    if (this.reportService.reportDetails && this.reportService.reportDetails.study_summary) {
      if (this.reportService.reportDetails.study_summary.status == 1 && this.reportService.reportDetails.study_summary.regenrate) {
        this.reportService.generateStudyAISummary(this.uuid).subscribe(result =>{
          if(result['status'] == 1){
            this.reportService.reportDetails.study_summary.status = 2;
            this.notifier.notify('warning','Summary generation is in progress');
          }else{
            this.notifier.notify("error","Something went wrong!")
          }
        });

      }else if (this.reportService.reportDetails.study_summary.status == 1 && !this.reportService.reportDetails.study_summary.regenrate) {
        this.notifier.notify('success','Summary is already updated');
      }else if (this.reportService.reportDetails.study_summary.status == 2) {
        this.notifier.notify('warning','Summary generation is in progress');
      }else if (this.reportService.reportDetails.study_summary.status == 3) {
        this.notifier.notify('warning','No VI file in this study');
      }else if (this.reportService.reportDetails.study_summary.status == 4) {
        this.notifier.notify('warning','The video transcription is too small for generating a summary (less than 1000 characters). Summary is generated on longer transcripts');
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    }
    
  }

  openGroupSummary(){
    this.reportService.openGroupSummary();
  }

}
